import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance
const API_FORMDATA = Axios.getInstanceForFormData

export const getAllUserList = (designationId, orgId, deptId) => {
    let URL = Endpoints.GET_ALL_USER_LIST
    URL = URL.replace('{designationId}', designationId)
    URL = URL.replace('{orgId}', orgId)
    URL = URL.replace('{deptId}', deptId)

    return API(Endpoints.API_ENDPOINT)
        .get(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const GetAllRolesAccess = (orgId) => {
    const params = { orgId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_ROLES_ACCESS, { params })
        .then(response => response)
        .catch(err => err)
}
export const GetAllRolesCheckboxs = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_ROLES_CHECKBOXS)
        .then(response => response)
        .catch(err => err)
}

export const createRolesPermissions = (roleData) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ROLES_PERMISSIONS, roleData)
        .then(response => response)
        .catch(err => err)
}

export const createRoles = (roleData) => {
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ROLES, roleData)
        .then(response => response)
        .catch(err => err)
}
export const getRoleById = (id) => {
    const params = { id }
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ROLE_BY_ID, { params })
        .then(response => response)
        .catch(err => err)
}

export const getSettingsdata = () => {
    const params = { isRecursive: true, isDownwardDirection: true }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_APPLICATION_SETTINGS, { params })
        .then(response => response)
        .catch(err => err)
}

export const getAllFeatures = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ALL_FEATURES)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getConfigTitles = () => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_CONFIGURATION_TITLES)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getConfigurationBasedOrganization = (orgId) => {
    let URL = Endpoints.GET_CONFIGURATION_BASED_ORGANIZATION
    URL = URL.replace('{orgId}', orgId)

    return API(Endpoints.API_ENDPOINT)
        .get(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const SetConfigurationBasedOrganization = (orgId, loginId, data) => {
    let URL = Endpoints.SET_CONFIGURATION_BASED_ORGANIZATION
    URL = URL.replace('{orgId}', orgId)
    URL = URL.replace('{loginId}', loginId)

    return API(Endpoints.API_ENDPOINT)
        .post(URL, data)
        .then((response) => response)
        .catch((err) => ({ err }))
}
